var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visivel
    ? _c(
        "div",
        {
          staticClass: "saldo-rodape mt-2 pt-2",
          class: {
            "saldo-rodape--recolhida d-flex justify-center": _vm.recolhida
          },
          attrs: { "data-test": "saldo-creditos-rodape" }
        },
        [
          _c(
            "button",
            {
              class: _vm.classeDoAtalho,
              attrs: {
                type: "button",
                title: _vm.tituloAtalho,
                "aria-label": _vm.ariaLabel,
                "data-test": "saldo-creditos-rodape-atalho"
              },
              on: { click: _vm.abrirModal }
            },
            [
              _c(
                "span",
                { staticClass: "saldo-rodape__icone" },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.iconeNome,
                      size: _vm.TAMANHO_ICONE,
                      color: _vm.iconeCor,
                      "data-test": "saldo-creditos-rodape-icone"
                    }
                  }),
                  _vm.recolhida && _vm.alertaDeSaldo
                    ? _c("span", {
                        staticClass: "saldo-rodape__ponto",
                        attrs: {
                          title: _vm.copy.SALDO_BAIXO_TITULO,
                          "data-test": "saldo-creditos-rodape-ponto"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              !_vm.recolhida
                ? [
                    _c("span", { staticClass: "saldo-rodape__rotulo" }, [
                      _vm._v(_vm._s(_vm.copy.TITULO))
                    ]),
                    _vm.loading
                      ? _c(
                          "div",
                          {
                            staticClass: "saldo-rodape__valor ml-auto",
                            attrs: {
                              "data-test": "saldo-creditos-rodape-loading"
                            }
                          },
                          [
                            _c("BaseLoadingSkeleton", {
                              attrs: { width: "48px", height: "12px" }
                            })
                          ],
                          1
                        )
                      : _vm.mostrarIndisponivel
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "saldo-rodape__valor saldo-rodape__valor--indisponivel ml-auto",
                            attrs: {
                              "data-test": "saldo-creditos-rodape-indisponivel"
                            }
                          },
                          [_vm._v(_vm._s(_vm.copy.RODAPE_INDISPONIVEL))]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "saldo-rodape__valor ml-auto",
                            class: {
                              "saldo-rodape__valor--negativo": _vm.negativo,
                              "saldo-rodape__valor--baixo": _vm.alertaDeSaldo
                            },
                            attrs: {
                              "data-creditos-exato": _vm.creditosRaw,
                              "data-test": "saldo-creditos-rodape-valor"
                            }
                          },
                          [_vm._v(_vm._s(_vm.creditosLabel))]
                        ),
                    _vm.alertaDeSaldo && !_vm.loading
                      ? _c("icon-svg", {
                          staticClass: "flex-shrink-0",
                          attrs: {
                            name: "warning-status",
                            size: _vm.TAMANHO_ICONE_ALERTA,
                            color: _vm.corAlerta,
                            role: "img",
                            title: _vm.copy.SALDO_BAIXO_TITULO,
                            "aria-label": _vm.copy.SALDO_BAIXO_TITULO,
                            "data-test": "saldo-creditos-rodape-alerta"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }